module.exports = __webpack_public_path__ + "static/media/pdf-icon.858e0aef.png";